import { useContext } from 'react';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';

// Context
import { BusinessPartnerContext } from './BusinessPartnerCard';
import BPSection from './BPSection';
import { SECTIONS } from './utils';

const BPCustomsAndCompliance = () => {
  const { localBPData, isEditing, handleOnChange, errors, dropdownValues, setShowDocumentsListModal } =
    useContext(BusinessPartnerContext);

  return (
    <>
      <section className="bp-customscompliance">
        <BPHeader />
        <BPSection
          sections={SECTIONS['bp-customscompliance']}
          isEditing={isEditing}
          localBPData={localBPData}
          dropdownValues={dropdownValues}
          errors={errors}
          handleOnChange={handleOnChange}
          handleShowModal={() => setShowDocumentsListModal(true)}
        />
      </section>
      <BPFooter />
    </>
  );
};

export default BPCustomsAndCompliance;
